import React from "react";
type Tone = "cream" | "white" | "blush" | "ink";
type SectionProps = {
  id?: string;
  tone?: Tone;
  wide?: boolean;
  children: React.ReactNode;
};
const toneClass: Record<Tone, string> = {
  cream: "bg-cream text-ink",
  white: "bg-white text-ink",
  blush: "bg-blush text-ink",
  ink: "bg-berryDark text-white"
};
export function Section({
  id,
  tone = "cream",
  wide = false,
  children
}: SectionProps) {
  return <section id={id} className={`px-4 py-14 md:py-20 ${toneClass[tone]}`} data-id="element-62" data-mp="cgzmhiap7w5f">
      <div className={`mx-auto ${wide ? "max-w-5xl" : "max-w-3xl"}`} data-id="element-63" data-mp="hf16q6jv21ih">{children}</div>
    </section>;
}
type HeadingProps = {
  kicker?: string;
  children: React.ReactNode;
  light?: boolean;
};
export function SectionHeading({
  kicker,
  children,
  light = false
}: HeadingProps) {
  return <div className="text-center" data-id="element-64" data-mp="ve0u7avn0ad2">
      {kicker && <p className={`text-[13px] font-bold uppercase tracking-[0.14em] ${light ? "text-petal" : "text-berry"}`} data-id="element-65" data-mp="vcfznl9borf7">
          {kicker}
        </p>}
      <h2 className={`mt-3 font-serif text-[30px] font-bold leading-[1.15] tracking-tight md:text-5xl ${light ? "text-white" : "text-ink"}`} data-id="element-66" data-mp="2zjsj6dmr1lf1">
        {children}
      </h2>
    </div>;
}